
export default class OrganizationModel {
  constructor(data) {
    if (!data) {
      // eslint-disable-next-line no-param-reassign
      data = {};
    }

    this.id = data.id || 0;
    this.email_address = data.email_address || '';
    this.name = data.name || '';
    this.phone_number = data.phone_number || '';
    this.phone_country_code = data.phone_country_code || '';
    this.phone_number_e164 = data.phone_number_e164 || '';
    this.number_of_devices = data.number_of_devices || 0;
    this.number_of_sites = data.number_of_sites || 0;
    this.allowed_to_remove_files = data.allowed_to_remove_files || false;
    this.is_removed = data.is_removed || false;
    this.kgb_admin_allowed_download_of_files = data.kgb_admin_allowed_download_of_files !== false;
    this.is_allowed_demo_access = data.is_allowed_demo_access !== false;
    this.is_allowed_data_encryption = data.is_allowed_data_encryption !== false;
    this.dart_software_version = data.dart_software_version || '';
  }
}
